
export const ACCESS_TOKEN = 'Authorization'
export const SIDEBAR_TYPE = 'sidebar_type'
export const TOGGLE_MOBILE_TYPE = 'is_mobile'
export const TOGGLE_NAV_THEME = 'nav_theme'
export const TOGGLE_LAYOUT = 'layout'
export const TOGGLE_FIXED_HEADER = 'fixed_header'
export const TOGGLE_FIXED_SIDEBAR = 'fixed_sidebar'
export const TOGGLE_CONTENT_WIDTH = 'content_width'
export const TOGGLE_HIDE_HEADER = 'auto_hide_header'
export const TOGGLE_COLOR = 'color'
export const TOGGLE_WEAK = 'weak'
export const TOGGLE_MULTI_TAB = 'multi_tab'
export const APP_LANGUAGE = 'app_language'

export const DEFAULT_SYSTEM_TYPE = 'default_system_type'
export const USER_INFO = 'user_info'
export const ADD_ROUTERS = 'vue_add_routers'
export const DYNAMIC_ROUTERS = 'dynamic_routers'
export const TOP_NAV = 'dynamic_top_nav'
export const CURRENT_NAV = 'current_top_nav'
export const USER_CURRENT_PROJECT = 'user_current_project'
export const USER_PROJECT = 'user_project'
export const DEFAULT_ROUTER = 'default_router'
export const PROJECT_CENTER_PERMISSION = 'project_center_permission'
export const PROJECT_CREATE_PERMISSION = 'project_create_permission'
export const CLOUD_CALL = 'cloud_call'

export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed'
}
export const NAV_THEME = {
  LIGHT: 'light',
  DARK: 'dark'
}
